import * as Yup from 'yup'

export const CombinedPIICollectionSchema = Yup.object().shape({
  ssn: Yup.string()
    .required('This field is required')
    .test('exact-digits', 'SSN must contain exactly 9 digits', (value) => {
      if (!value) {
        return false
      }
      const digitsOnly = value.replace(/\D/g, '')

      return digitsOnly.length === 9
    }),
  ssnFile: Yup.mixed<File>().nullable().required('This field is required'),
  workAuthorization: Yup.boolean().required(),
  workAuthFile: Yup.mixed<File>()
    .nullable()
    .when('workAuthorization', {
      is: true,
      then: (schema) => schema.required('This field is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  streetAddress: Yup.string().required('This field is required'),
  city: Yup.string().required('This field is required'),
  state: Yup.string().required('This field is required'),
  zipCode: Yup.string().required('This field is required'),
})
